(ns minorodata.connections.sources.affiliate
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "affiliate"
   :enabled      true
   :name         "Affiliate Future"
   :description  "Provides advertisers with an effective marketing solution through its affiliate network and tools"
   :image-source "future-affiliate.png"
   :tags         ["marketing"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                (let [{:keys [name description api-key passcode]} data]
                  {:source-type "affiliate"
                   :name        name
                   :description description

                   :source
                                {:credentials         {:api-key   api-key
                                                       :passcode  passcode}}}))

    :format-for-inputs
              (fn [data]
                (let [{:keys [source name description]} data
                      {:keys [credentials]} source]
                  (merge
                    (select-keys credentials [:api-key :passcode])
                    {:name              name
                     :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :affiliate-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "API-KEY"
              :required   true
              :name       :api-key
              :value      ""}
             {:block-type :input
              :label      "Passcode"
              :required   true
              :name       :passcode
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
              (fn [data]
                (let [{:keys [name extract-type description status action destination-table
                              report start-date end-date]} data]
                  (cond-> {:name          name
                           :description   description
                           :status        status
                           :output-tables [destination-table]

                           :config
                           {:extracts [{:report            report
                                        :extract-type      extract-type
                                        :start-date        start-date
                                        :end-date          end-date
                                        :destination-table destination-table
                                        :action            action}]}})))

    :format-for-inputs
              (fn [data]
                (let [{:extract/keys [name description status config]} data

                      extract (get-in config [:extracts 0])]
                  (merge
                    (select-keys extract [:report :action :extract-type :start-date :end-date :destination-table])
                    (app.utils/keep-non-nil-keys
                      {:name          name
                       :description   description
                       :status        status}))))

    :validate (constantly nil)

    :id :affiliate-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Endpoint Service"
              :name       :report
              :options    [{:name "Payments"                  :value "payments"}
                           {:name "Merchants"                 :value "merchants"}
                           {:name "Transactions"              :value "transactions"}
                           {:name "Voucher"                   :value "voucher"}
                           {:name "Cancellations"             :value "cancellations"}
                           {:name "Second Level Transactions" :value "second_level_transactions"}]
              :required   true
              :value      "payments"}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Interval"    :value "interval"}
                           {:name "Incremental" :value "incremental"}]
              :value      "interval"
              :required   false
              :conditions [[:eq [:report :value]  "payments"]
                           [:eq [:report :value]  "transactions"]
                           [:eq [:report :value]  "voucher"]
                           [:eq [:report :value]  "cancellations"]
                           [:eq [:report :value]  "second_level_transactions"]]}

             {:block-type :date-picker
              :label "From"
              :name :start-date
              :required false
              :conditions [[:eq [:report :value]  "payments"]
                           [:eq [:report :value]  "transactions"]
                           [:eq [:report :value]  "voucher"]
                           [:eq [:report :value]  "cancellations"]
                           [:eq [:report :value]  "second_level_transactions"]]}

             {:block-type :date-picker
              :label "To"
              :name :end-date
              :required false
              :conditions [[:and [[:report :value] [:extract-type :value]] ["payments" "interval"]]
                           [:and [[:report :value] [:extract-type :value]] ["transactions" "interval"]]
                           [:and [[:report :value] [:extract-type :value]] ["voucher" "interval"]]
                           [:and [[:report :value] [:extract-type :value]] ["cancellations" "interval"]]
                           [:and [[:report :value] [:extract-type :value]] ["second_level_transactions" "interval"]]]}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})


